<template>
  <v-card flat class="pr-4 py-4" style="background-color: transparent">
    <v-progress-linear background-opacity="0.3" :height="height" :value="value" :color="color"></v-progress-linear>
  </v-card>
</template>

<script>
// @group Common
// Styled ProgressLinear component

export default {
  name: 'ProgressLinear',
  props: {
    //has height
    height: {
      // `Number`
      type: Number,
      // The default value is: `5`
      default: 5
    },
    //has value
    value: {
      // `Number`
      type: Number,
      // The default value is: `0`
      default: 0
    },
    //has default color
    color: {
      // `String`
      type: String,
      default: '#224277'
    }
  }
}
</script>

<style>
</style>
